import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../Button';
import { cn } from '@/utils/cn';

interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  page,
  pageSize,
  total,
  onPageChange,
  className,
}) => {
  const totalPages = Math.ceil(total / pageSize);
  const startItem = page * pageSize + 1;
  const endItem = Math.min((page + 1) * pageSize, total);

  if (total === 0) return null;

  return (
    <div className={cn('flex items-center justify-between p-4', className)}>
      <div className="text-sm text-gray-500 dark:text-zinc-400">
        Zobrazeno <span className="font-medium text-gray-900 dark:text-zinc-200">{startItem}</span>{' '}
        až <span className="font-medium text-gray-900 dark:text-zinc-200">{endItem}</span> z{' '}
        <span className="font-medium text-gray-900 dark:text-zinc-200">{total}</span> záznamů
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 0}
          leftIcon={<ChevronLeft size={16} />}
        >
          Předchozí
        </Button>
        <span className="text-sm font-medium text-gray-700 dark:text-zinc-300 px-2">
          Strana {page + 1} z {totalPages || 1}
        </span>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages - 1}
          rightIcon={<ChevronRight size={16} />}
        >
          Další
        </Button>
      </div>
    </div>
  );
};
